import { HTTP_USERS, HTTP_DESKRH } from '../http';

export default {

  getUsers(searchParams) {
    return HTTP_USERS.post(`${process.env.API_USERS_LISTING_ROUTE}`, searchParams)
      .then(data => data.data.data);
  },

  getUser(id) {
    return HTTP_USERS.get(`${process.env.API_USERS_ROUTE}/${id}`)
      .then(data => data.data.data);
  },

  updateUser(user) {
    return HTTP_USERS.put(`${process.env.API_USERS_ROUTE}/${user.id}`, user)
      .then(data => data.data.data);
  },

  changePassword(params) {
    return HTTP_USERS.post(`${process.env.API_USERS_LISTING_ROUTE}/change-password`, params)
      .then(data => data);
  },

  getCurrentUser() {
    return HTTP_USERS.get(`${process.env.API_USERS_ROUTE}/current`)
      .then(data => data);
  },

  reinitUserPassword(params) {
    return HTTP_DESKRH.post('/reinit-password', params)
      .then(response => response.data.data);
  },
};



// WEBPACK FOOTER //
// ./src/api/users.js